export default ["GB","GBNI","ZA"]